//import projects
import Template from './Template';
import prompts from '../../../dummy_data/prompt_engineer/finance.json';
// External variant
const options = [
    'Đánh giá cơ hội đầu tư tiềm năng',
    'Lên chiến lược đầu tư',
    'Xây dựng mô hình tài chính',
    'Nghiên cứu thị trường',
    'Phân tích báo cáo tài chính',
    'Quản lý rủi ro'
];

const prompt_persona_role =
    'Phản hồi như một chuyên gia tài chính, giúp đưa ra quyết định tài chính thông minh, đảm bảo sự ổn định và tăng trưởng tài chính lâu dài.';

export default function Finance() {
    return (
        <Template personaRole={prompt_persona_role} data={prompts} title="Tài chính" options={options} project="prompt_engineer/finance" />
    );
}
